import React, { useContext, useEffect, useState } from "react";
import {
  TextField,
  Button,
} from "@mui/material";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast from "react-hot-toast";
import blogFetch from "../../../axios/config";
import Context from "../../../context/Context";

const INITIAL_STATE_CREATE_PENDENCY = {
  Pend_Ordem: "",
  Pend_Status: "ABERTO",
  Pend_Mot_key: 0,
  PendMot_Responsavel: ""
}

interface IDefeitoGSA {
  defeito_Key: number;
  defeito_Descricao: string;
  defeito_Ativo: boolean;
  _Mod: string;
  _ts_Mod: Date;
}

export interface IGSA {
  GSA_Ordem: string | null;
  GSA_Status: string | null;
  GSA_Defeito_Key: number | null;
  _Creat: string | null;
  GSA_DataRetrabalho?: Date | null;
  GSA_SaidaRetrabalho?: Date | null;
  GSA_SetorRetrabalho_Key?: number | null
}


function GSAModal({ data, setIdScreenFicha }: { data: any; setIdScreenFicha: any }) {
  const [body, setBody] = useState(INITIAL_STATE_CREATE_PENDENCY);
  const [loading, setLoading] = useState(false);
  const [defect, setDefect] = useState("");

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const {
    statusPendencia,
    setShowModalFicha,
    selectedCountry
  } = useContext(Context);
  const [defects, setDefects] = useState<IDefeitoGSA[]>([]);

  useEffect(() => {
    setBody({
      ...body,
      Pend_Ordem: data.ordem,
    });
    getDefects();
  }, [])

  const getDefects = async () => {
    try {
      setLoading(true);
      const response = await blogFetch.get(`/DefectsGSA/get`);
      setDefects(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const submitGSA = async () => {
    try {

      const gsa: IGSA = {
        GSA_Ordem: data.ordem,
        GSA_Status: "Em analise",
        GSA_Defeito_Key: Number(defect),
        _Creat: user.user_UserName ?? user.user_Matricula
      };
      const response = await blogFetch.post(`/DefectsGSA/create`, gsa);
      if (response.data.success) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }

    } catch (error: any) {
      toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");

    }
    finally {
      setShowModalFicha(false);
    }
  };


  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column p-3">
        <h2
          className="d-flex justify-content-center"
          style={{ fontFamily: "sans-serif" }}
        >
          Enviar peça para o GSA
        </h2>
        {loading ? (
          <div>
            <FontAwesomeIcon icon={faSpinner} spin size="2x" />
          </div>
        ) : (
          <div className="d-flex flex-column">
            <div className="d-flex flex-row gap-3">
              <div style={{ width: 320 }}>
                <label htmlFor="ordem-input" className="form-label fw-bold">Ordem</label>
                <input
                  id="ordem-input"
                  type="text"
                  className="form-control"
                  value={data.ordem}
                  disabled
                  readOnly
                />
              </div>

            </div>
            <div className="w-100 mt-3 h-10">

              <select value={defect} className="form-select" aria-label="Default select example"
                onChange={(e) => setDefect(e.target.value)}
              >
                <option value="" selected>Selecionar defeito...</option>
                {defects.map(defect2 => {
                  return (
                    <option key={defect2.defeito_Key} value={defect2.defeito_Key}>
                      {defect2.defeito_Descricao}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="d-flex flex justify-content-end mt-3">
              <Button
                variant="contained"
                onClick={() => submitGSA()}
                disabled={defect == ""}
              >
                <div>
                  Salvar
                </div>
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GSAModal;
